module.exports = __webpack_public_path__ + "static/media/GI.125f8cf0.svg";